import React from "react";
import "./contact.css";
import Topbar from "../../components/Topbar/Topbar";
import Form from "../../components/Form/Form";
import Footer from "../../components/Footer/Footer";

const Contact=()=>{
    return(
        <>
            <Topbar/>
            <div className="contact-container">
                <Form/>
                <Footer/>
            </div>
        </>
    )
}

export default Contact;